export async function copyPlainTextToClipboard(text: string): Promise<void> {
  await navigator.clipboard.writeText(text);
}

export async function copyRichTextToClipboard(html: string, plainText: string): Promise<void> {
  const ClipboardItemCtor = typeof window !== 'undefined'
    ? (window as any).ClipboardItem
    : undefined;

  if (ClipboardItemCtor && navigator.clipboard?.write) {
    const item = new ClipboardItemCtor({
      'text/html': new Blob([html], { type: 'text/html' }),
      'text/plain': new Blob([plainText], { type: 'text/plain' }),
    });
    await navigator.clipboard.write([item]);
    return;
  }

  await copyPlainTextToClipboard(plainText);
}
